import { publicInstance } from '@/api/axiosInstance';
import { PECAI_API_URL } from '..';
import { getPecaAiAccessToken } from '../../enterprise/pecaAi/pecaAi.hooks';
import {
  PecaAiBasketCreateRequest,
  PecaAiBasket,
  PecaAiBasketShippingsRequest,
  PecaAiBasketShippings,
  PecaAiBasketVouncherRequest,
  PecaAiBasketUpdateRequest,
  PecaAiBasketOrdersRequest,
  PecaAiBasketRemoveItemRequest,
  PecaAiBasketEditItemRequest,
  PecaAiBasketDetail,
  PecaAiAddProductInBasketRequest,
  PecaAiRemoveProductInBasketRequest,
  PecaAiGenerateOrder,
  PecaAiBasketSummary,
} from './pecaAiBasket.types';
import pecaAiServices from '../../enterprise/pecaAi/pecaAi.services';

const CONTROLLER = (document?: string) =>
  `${PECAI_API_URL}/buyers/${document}/baskets`;

export default {
  async detailBasket(params: { basketId?: string; document?: string }) {
    const token = await pecaAiServices.getToken();

    const response = await publicInstance.get<PecaAiBasketDetail>(
      `${CONTROLLER(params.document)}/${params.basketId}`,
      { headers: { Authorization: `Bearer ${token.access_token}` } },
    );

    return response.data;
  },

  async basketSummary(params: { basketId?: string; document?: string }) {
    const token = await pecaAiServices.getToken();

    const response = await publicInstance.get<PecaAiBasketSummary>(
      `${CONTROLLER(params.document)}/${params.basketId}/summary`,
      { headers: { Authorization: `Bearer ${token.access_token}` } },
    );

    return response.data;
  },

  async createBasket({ buyer: Buyer, ...data }: PecaAiBasketCreateRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.post<PecaAiBasket>(
      CONTROLLER(''),
      data,
      {
        headers: { Buyer, Authorization: `Bearer ${token?.access_token}` },
      },
    );

    return response.data;
  },

  async updateBasket({
    buyer: Buyer,
    basketId,
    ...data
  }: PecaAiBasketUpdateRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.put<PecaAiBasket>(
      `${CONTROLLER}/${basketId}`,
      data,
      { headers: { Buyer, Authorization: `Bearer ${token?.access_token}` } },
    );

    return response.data;
  },

  async shippingsBasket({
    buyer: Buyer,
    basketId,
  }: PecaAiBasketShippingsRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.get<PecaAiBasketShippings>(
      `${CONTROLLER}/${basketId}/shippings`,
      { headers: { Buyer, Authorization: `Bearer ${token?.access_token}` } },
    );

    return response.data;
  },

  async vouncherBasket({
    buyer: Buyer,
    basketId,
    ...data
  }: PecaAiBasketVouncherRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.post<PecaAiBasketShippings>(
      `${CONTROLLER}/${basketId}/shippings`,
      data,
      { headers: { Buyer, Authorization: `Bearer ${token?.access_token}` } },
    );

    return response.data;
  },

  async ordersBasket(params: PecaAiBasketOrdersRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.post<PecaAiBasketShippings>(
      `${CONTROLLER}/${params.basketId}/orders`,
      null,
      {
        headers: {
          Buyer: params.buyer,
          Authorization: `Bearer ${token?.access_token}`,
        },
      },
    );

    return response.data;
  },

  async removeItemBasket(params: PecaAiBasketRemoveItemRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.delete<void>(
      `${CONTROLLER}/${params.basketId}/products/${params.productId}`,
      {
        headers: {
          Buyer: params.buyer,
          Authorization: `Bearer ${token?.access_token}`,
        },
      },
    );

    return response.data;
  },

  async editItemBasket(params: PecaAiBasketEditItemRequest) {
    const token = getPecaAiAccessToken();

    const response = await publicInstance.patch<void>(
      `${CONTROLLER}/${params.basketId}/products/${params.productId}`,
      { amount: params.amount },
      {
        headers: {
          Buyer: params.buyer,
          Authorization: `Bearer ${token?.access_token}`,
        },
      },
    );

    return response.data;
  },

  async addProductInBasket({
    document,
    basketId,
    ...data
  }: PecaAiAddProductInBasketRequest) {
    const token = await pecaAiServices.getToken();

    const response = await publicInstance.post<void>(
      `${CONTROLLER(document)}/${basketId}/products`,
      data,
      { headers: { Authorization: `Bearer ${token.access_token}` } },
    );

    return response;
  },

  async removeProductInBasket(params: PecaAiRemoveProductInBasketRequest) {
    const token = await pecaAiServices.getToken();

    const response = await publicInstance.delete<void>(
      `${CONTROLLER(params.document)}/${params.basketId}/products/${
        params.productId
      }`,
      { headers: { Authorization: `Bearer ${token.access_token}` } },
    );

    return response;
  },

  async generateOrder(params: PecaAiGenerateOrder) {
    const token = await pecaAiServices.getToken();

    const response = await publicInstance.post<void>(
      `${CONTROLLER(params.document)}/${params.basketId}/orders`,
      null,
      { headers: { Authorization: `Bearer ${token.access_token}` } },
    );

    return response;
  },
};
